module.exports = __webpack_public_path__ + "static/media/delete.c73a97db.png";